import { render, staticRenderFns } from "./ModalConfirmBroadcast.vue?vue&type=template&id=38f94e3e&"
import script from "./ModalConfirmBroadcast.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmBroadcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports